import { useState, useEffect } from "react";
import { getAllpartners } from "../../../Services/APIrequests";
import { Banner } from "./Banner";
import styles from "./home.module.css";

export default function OurPartners() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await getAllpartners();
        if (response.data && response.data.partners) {
          setPartners(
            response.data.partners?.map((partner) => ({
              id: partner.id,
              image: partner.logo,
              redirectLink: partner?.redirectLink,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching partners:", error);
      }
    };
    fetchPartners();
  }, []);

  // Create an array of image objects from partners data
  // const images = partners

  return (
    <div className={styles.ourPartnersApp}>
      <h1 className={styles.samplenlogtext}>Our Partners</h1>
      {partners.length > 0 ? (
        <Banner images={partners} speed={5000} />
      ) : (
        <p style={{textAlign:"center"}}>Loading partners...</p>
      )}
    </div>
  );
}
